import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { useHasFinePointer } from "@/hooks/useHasFinePointer";

// Soft radial cursor glow that follows the pointer. Fixed layer, non-interactive.
const CursorGlow = () => {
    const hasFinePointer = useHasFinePointer();
    const x = useMotionValue(-500);
    const y = useMotionValue(-500);
    const springX = useSpring(x, { stiffness: 120, damping: 20, mass: 0.4 });
    const springY = useSpring(y, { stiffness: 120, damping: 20, mass: 0.4 });

    useEffect(() => {
        if (!hasFinePointer) return;
        const move = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
        };
        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, [hasFinePointer, x, y]);

    if (!hasFinePointer) return null;

    return (
        <motion.div
            aria-hidden
            className="pointer-events-none fixed inset-0 z-[5]"
            style={{ willChange: "transform" }}
        >
            <motion.div
                className="absolute h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full"
                style={{
                    x: springX,
                    y: springY,
                    background:
                        "radial-gradient(closest-side, rgba(59,130,246,0.14), rgba(6,182,212,0.06) 45%, rgba(5,5,5,0) 70%)",
                    filter: "blur(30px)"
                }}
            />
        </motion.div>
    );
};

export default CursorGlow;
